/**
 * Textos de auth em pt-BR (CLAUDE.md 8).
 *
 * Centralizados por feature para facilitar i18n depois, e porque o tom faz
 * parte do produto: quem usa o app dos pais costuma estar cansado no fim de
 * um dia dificil. Nada de "credenciais invalidas" nem "falha na autenticacao".
 */
export const authCopy = {
  parents: {
    title: "Olá! Que bom ver você",
    subtitle: "Entre para registrar o dia do seu filho.",
    submit: "Entrar",
    submitting: "Entrando...",
  },
  therapist: {
    title: "Painel do Terapeuta",
    subtitle: "Acompanhe seus pacientes entre as sessões.",
    submit: "Entrar no painel",
    submitting: "Entrando...",
  },
  admin: {
    title: "Admin da Plataforma",
    subtitle: "Gestão de clínicas e configurações.",
    submit: "Entrar",
    submitting: "Entrando...",
  },
  fields: {
    email: "E-mail",
    emailPlaceholder: "voce@exemplo.com",
    password: "Senha",
    passwordPlaceholder: "Sua senha",
    showPassword: "Mostrar senha",
    hidePassword: "Ocultar senha",
  },
  errors: {
    // Deliberadamente igual para senha errada e conta inexistente: o backend
    // nao diferencia os dois (RNF-02.4) e a UI nao pode reintroduzir a
    // distincao que ele tomou o cuidado de apagar.
    invalidCredentials: "E-mail ou senha inválidos.",
    tenantRequired: "Não conseguimos identificar a clínica. Confira o endereço de acesso.",
    tenantSuspended: "O acesso desta clínica está suspenso. Fale com o suporte.",
    rateLimited: (seconds: number) =>
      `Muitas tentativas. Tente de novo em ${seconds} segundo${seconds === 1 ? "" : "s"}.`,
    authUnavailable: "Serviço temporariamente indisponível. Tente de novo em instantes.",
    network: "Sem conexão com o servidor. Verifique sua internet.",
    generic: "Não foi possível entrar agora. Tente de novo.",
  },
  tagline: "Entre sessões, seguimos juntos.",

  forgotPassword: {
    title: "Esqueci minha senha",
    subtitle: "Informe seu e-mail e enviaremos instruções para redefinir a senha.",
    submit: "Enviar instruções",
    submitting: "Enviando...",
    // Mesma mensagem exista ou nao a conta (RNF-02.4) — nao ha "sucesso"
    // diferente de "e-mail nao encontrado" aqui, de proposito.
    sent: "Se o e-mail existir, você vai receber as instruções em instantes.",
    backToLogin: "Voltar para o login",
  },

  setPassword: {
    activateTitle: "Crie sua senha",
    activateSubtitle: "Falta pouco! Defina uma senha para começar a usar o iLumeConecta.",
    resetTitle: "Redefinir senha",
    resetSubtitle: "Escolha uma nova senha para sua conta.",
    passwordLabel: "Nova senha",
    confirmLabel: "Confirme a nova senha",
    submit: "Salvar e entrar",
    submitting: "Salvando...",
    invalidToken: "Este link não é mais válido. Peça um novo.",
    missingToken: "Link inválido — faltam informações. Confira o e-mail que você recebeu.",
  },

  findTenant: {
    trigger: "Não sabe o endereço da sua clínica?",
    title: "Encontrar minha clínica",
    subtitle: "Informe seu e-mail e mandamos um link para cada clínica onde você tem conta.",
    // Mostrado no lugar do form de senha quando a pagina esta no dominio raiz
    // (sem subdominio de tenant): entrar com senha aqui sempre falharia com
    // "nao conseguimos identificar a clinica", entao nem oferecemos o campo.
    autoNotice: "Este endereço não é de uma clínica específica. Informe seu e-mail que mandamos o link certo.",
    submit: "Enviar",
    submitting: "Enviando...",
    // Mesma logica do reset de senha (RNF-02.4): a mensagem nunca muda,
    // exista o e-mail em 0, 1 ou 10 clinicas — a lista de verdade so existe
    // dentro do e-mail, nunca aqui nem em redirecionamento automatico.
    sent: "Se esse e-mail pertencer a alguma clínica, você vai receber um link de acesso em instantes.",
    backToLogin: "Voltar para o login",
  },

  consent: {
    title: "Antes de começar",
    description: "Pedimos um minuto para explicar como cuidamos dos dados do seu filho ou filha.",
    body:
      "O iLumeConecta registra informações sensíveis sobre a saúde e o desenvolvimento de " +
      "crianças — humor, comportamento, sono e alimentação do dia a dia. Esses dados são usados " +
      "exclusivamente para que o terapeuta responsável acompanhe a evolução do tratamento, " +
      "seguindo a Lei Geral de Proteção de Dados (LGPD). Eles não são compartilhados fora da " +
      "equipe que cuida da criança. Ao continuar, você concorda com esse tratamento de dados.",
    accept: "Aceito o termo",
    accepting: "Enviando...",
    error: "Não foi possível registrar o aceite. Tente de novo.",
  },
} as const;
